import { Component, ElementRef, NgZone } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppoggioService } from 'src/app/_servizi/appoggio.service';
import { CantinaService } from 'src/app/_servizi/cantina.service';
import { MessageServiceService } from 'src/app/_servizi/message-service.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent {
  get fromMobile() {
    return this.appoggioService.getFromMobile();
  }

  observer!: ResizeObserver;

  checkAbilitato = false;
  abilitato = false;
  nonabilitatoMsg = '';

  codiceForm: any;
  linguaCorrente: string;

  loading = false;
  faqs = [];

  constructor(
    private messageService: MessageServiceService,
    private host: ElementRef,
    private zone: NgZone,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private cantinaService: CantinaService,
    private appoggioService: AppoggioService,
  ) { }


  ngOnInit(): void {


    this.route.paramMap.subscribe((params) => {
      this.codiceForm = params.get('cantina');
      this.linguaCorrente = params.get('lingua');
      this.translate.use(this.linguaCorrente);
      this.controllaCantina(this.codiceForm);
    });

    this.observer = new ResizeObserver(entries => {
      this.zone.run(() => {
        this.messageService.sendHeighMessageFaq(entries[0].contentRect.height);
      });
    });

    this.observer.observe(this.host.nativeElement);

  }

  ngOnDestroy(): void {
    this.observer.unobserve(this.host.nativeElement);
  }

  controllaCantina(codiceForm): void {
    this.loading = true;
    this.cantinaService.getStato(codiceForm)
      .subscribe(result => {
        this.checkAbilitato = true;
        if (result && result.length > 0) {
          const cantina = result[0];
          this.abilitato = true
          this.appoggioService.setCodiceForm(codiceForm);

          this.appoggioService.setColoriIframe(cantina);

          this.cantinaService.getFaqs(codiceForm, this.linguaCorrente)
            .subscribe(result => {
              this.faqs = result;
            });

        } else {
          this.abilitato = false;
          this.nonabilitatoMsg = 'nonAbilitato';
        }
        setTimeout(() => {
          this.loading = false;
        }, 2000)
      });
  }
}
